if (!Math.trunc) {
    Math.trunc = x => (x > 0 ? Math.floor : Math.ceil)(x);
}
